module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'wo7tb6v5',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
